const queue = [];
let current = null;

export default (store) => {
  async function next() {
    if (current || !queue.length) {
      return;
    }

    const { req, resolve } = queue.shift();

    current = req;

    if (req && typeof req === 'function') {
      current = req();
    }

    resolve(current);

    try {
      await current;
    } catch (e) {
      // go to next
    }

    current = null;
    next();
  }

  store.$q = req => new Promise((resolve, reject) => {
    queue.push({ req, resolve, reject });
    next();
  });
};
